import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { BetweenDates } from '@common/models/between-dates';

@Component({
  selector: 'between-dates',
  templateUrl: './between-dates.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BetweenDatesComponent implements OnInit {

  @Input() model: BetweenDates;
  @Output() modelChange = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    if (!this.model) {
      this.model = { field1: null, field2: null };
    } else if (typeof this.model.field1 === 'string') {
      this.model = {
        field1: new Date(this.model.field1),
        field2: new Date(this.model.field2)
      };
    }
  }

  onValueChange(): void {
    this.modelChange.emit(this.model);
  }
}
